// File Display Component

import { Box, IconButton, List, ListItem, ListItemText } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers";

export const FileDisplay = ({
  files,
  removeFileFromArr,
}: {
  files: File[];
  removeFileFromArr: (fileName: string) => void;
}) => {
  return (
    <Box sx={{ minHeight: 40 }}>
      <List dense sx={{ py: 0 }}>
        {files.map((file, index) => (
          <ListItem
            key={index}
            sx={{ py: 0.25, pr: 5 }}
            secondaryAction={
              <IconButton
                edge="end"
                onClick={() => removeFileFromArr(file.name)}
              >
                <ClearIcon />
              </IconButton>
            }
          >
            <ListItemText
              primary={file.name}
              secondary={`${(file.size / 1024).toFixed(2)} KB`}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
